import React from 'react';

export class AppAvatar extends React.Component {
   render() {
      return <div></div>
      // return <div className='neo-icon-socket-connected'></div>
   }
};
